import { forwardRef, ReactNode } from "react";
import cn from "classnames";
import styles from "./PanelView.module.scss";

type ViewProps = {
  shouldRenderMoreButton?: boolean;
  loadMoreButton?: JSX.Element;
  className?: string;
  id?: string;
  children: ReactNode;
};

export const PanelView = forwardRef<HTMLDivElement, ViewProps>(
  ({ shouldRenderMoreButton, className, id, children, loadMoreButton }, ref) => (
    <div ref={ref} className={cn(styles.view, className)} id={id}>
      {children}
      <div className={styles.loadMoreBtnWrapper}>{shouldRenderMoreButton && loadMoreButton}</div>
    </div>
  )
);

PanelView.displayName = PanelView.name;
